// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/add_button.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/button_2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/button_search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/button_filter.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/clear_button.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/settingIcon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/show.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/print.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/VectorDelete.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productsView_wrapper__OiKbN {
  width: 85%;
  padding: 30px;
  margin-left: auto;
}

.productsView_header__tz4XV {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  position: relative;
  padding-bottom: 12px; /* отступ перед линией */
}

.productsView_header__tz4XV::before {
  content: '';
  z-index: 0;
  position: absolute;
  bottom: 11px;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #e0e0e0;
}


.productsView_tabButton__1TqQu {
  position: relative;
  background: none;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.productsView_tabButton__1TqQu:hover {
  background-color: #e0e0e0;
}

.productsView_active__AAjak::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: rgba(29, 135, 82, 1);
}
.productsView_active__AAjak {
  color: rgba(29, 135, 82, 1);
}

/* Секция кнопок */
.productsView_actions__bCqoZ {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.productsView_addButton__gTqBg {
  position: relative;
  padding: 10.5px 40px 10.5px 18px;
  background-color: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.productsView_addButton__gTqBg::after {
  content: '';
  position: absolute;
  bottom: 14px;
  right: 15px;
  height: 8px;
  width: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 13.5px 7.5px;
}

.productsView_actionButton__J8-vU {
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});  
  background-size: contain;
  background-repeat: no-repeat;
}

/* Секция фильтрации */
.productsView_filters__gDyM- {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
}

.productsView_filters__select__yqlor {
  width: 21%;
  margin-right: 1%;
}

.productsView_select__Y\\+Ki\\+{
  padding: 8px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  min-width: 120px;
}

tr {
  border: 1px solid #ccc;
}

.productsView_searchButton__5dJDy {
  margin-right: 1%;
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});  
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}

.productsView_searchInput__95bW8 {
  opacity: 0;
  width: 0;
  margin-right: 1%;
  padding: 8px;
  font-size: 14px;
  border-radius: 6px;
  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;
  overflow: hidden;
}

.productsView_searchInputVisible__P7f6a {
  opacity: 1;
  width: 160px;
  height: 39px;
  border: 1px solid rgba(203, 213, 225, 1);
  margin-right: 8px;
}


.productsView_filterButton__A7Hbu {
  width: 45px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});  
  background-repeat: no-repeat;
  cursor: pointer;
}

.productsView_clearButton__VNvYF {
  width: 40px;
  height: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});  
  background-repeat: no-repeat;
  cursor: pointer;
}

.productsView_content__eS0xy {
  margin-top: 24px;
  border-radius: 8px;
}


.productsView_dropdownWrapper__W-fhP {
  position: relative;
}

.productsView_dropdown__2Lory {
  position: absolute;
  top: 40px;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 200px;
}

.productsView_dropdown__2Lory button {
  background: none;
  border: none;
  text-align: left;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.productsView_dropdown__2Lory button:hover {
  background-color: #f0f0f0;
}

.productsView_tableWrapper__YAJGG {
  max-height: 27vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; /* на всякий случай */
}

/* убери overflow:hidden у самой таблицы, иначе может клипать */
.productsView_table__UMPhq {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  /* overflow: hidden;  <-- убираем */
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* фиксируем шапку внутри scroll-контейнера */
.productsView_table__UMPhq thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}

.productsView_page__ZB2py {
  color: red;
}
.productsView_table__UMPhq th,
.productsView_table__UMPhq td {
  padding: 12px 16px;
  text-align: left;
  font-size: 14px;
}

.productsView_table__UMPhq th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.productsView_table__UMPhq tr:hover {
  background-color: #f5f5f5;
}

.productsView_checkboxContainer__c9v1e {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.productsView_checkboxContainer__c9v1e input {
  opacity: 0;
  width: 0;
  height: 0;
}

.productsView_customCheckbox__pC-Wi {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid #1D8752;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.productsView_checkboxContainer__c9v1e input:checked + .productsView_customCheckbox__pC-Wi {
  background-color: #1D8752;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: center;
}

.productsView_pagination__MpN7T {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 16px;
  padding-bottom: 10px;
  flex-wrap: wrap;
}

.productsView_pageButton__05Pzs {
  cursor: pointer;
  padding: 5.5px 6px;
}

.productsView_pageButtonSymbol__kvY9f {
  cursor: pointer;
  padding: 5.5px 6px;
  border-radius: 3px;
  border: 1px solid rgba(201, 201, 205, 1);
}

.productsView_pageButton__05Pzs:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.productsView_activePage__8JR7r {
  border: 1px solid rgba(24, 160, 88, 1);
  color: rgba(24, 160, 88, 1);
  border-radius: 3px;
}

.productsView_pageDots__9TKmn {
  padding: 6px 10px;
  color: #999;
}

.productsView_table__UMPhq th:last-child,
.productsView_table__UMPhq td:last-child{
  padding: 0 15px 0 0;
}

.productsView_tDots__kTqo7 {
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none !important;
  padding: 0 !important;
}

.productsView_optionsButton__x\\+p7q {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productsView_dots__chmog {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.productsView_dot__w-DPw {
  width: 4px;
  height: 4px;
  background-color: #666;
  border-radius: 50%;
}

.productsView_settingIcon__9aYOA {
  display: block;
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
}

.productsView_rowDropdown__RqFYe {
  position: absolute;
  right: 0;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 20;
  display: flex;
  flex-direction: column;
  min-width: 160px;
}

.productsView_rowDropdown__RqFYe button {
  background: none;
  border: none;
  padding: 10px 16px;
  text-align: left;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.productsView_rowDropdown__RqFYe button:hover {
  background-color: #f5f5f5;
}

.productsView_tDots__kTqo7 {
  position: relative;
}

.productsView_dropdownWrapper__W-fhP {
  position: relative;
}

.productsView_optionsDropdown__IzEvk {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  min-width: 222px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.productsView_optionsDropdown__IzEvk button {
  padding: 10px 32px;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
}

.productsView_optionsDropdown__IzEvk button:hover {
  background-color: #f0f0f0;
}

.productsView_show__jgN9r{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}

.productsView_edit__HKX7S{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}

.productsView_print__lhN9X{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: 10px 9px;
  background-size: 16px;
}

.productsView_delete__3FqO6{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}

/* productsView.module.css */
/* ТВОЙ CSS оставь как есть, ниже добавь/замени только нужное */

/* ✅ портальное меню поверх таблицы (не клипается overflow) */
.productsView_optionsDropdownPortal__dBeOQ {
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  min-width: 222px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.productsView_optionsDropdownPortal__dBeOQ button {
  padding: 10px 32px;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  background: none;
}

.productsView_optionsDropdownPortal__dBeOQ button:hover {
  background-color: #f0f0f0;
}

/* ✅ оставь твои иконки как есть (они работают по классам) */
.productsView_show__jgN9r{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}

.productsView_edit__HKX7S{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}

.productsView_print__lhN9X{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: 10px 9px;
  background-size: 16px;
}

.productsView_delete__3FqO6{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: 10px 7px;
  background-size: 16px;
}


/* фиксируем ширину колонки с точками (и с шестеренкой в header) */
.productsView_table__UMPhq th:last-child,
.productsView_table__UMPhq td:last-child {
  width: 56px;
  min-width: 56px;
  max-width: 56px;
  padding: 0 !important;
  text-align: center;
  vertical-align: middle;
}

/* ВАЖНО: td не должен быть flex */
.productsView_tDots__kTqo7 {
  cursor: pointer;
  border: none !important;
  padding: 0 !important;
  text-align: center;
}

/* сама кнопка — фикс размер, центр */
.productsView_optionsButton__x\\+p7q {
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0 auto;
  background: none;
  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
}

.productsView_dots__chmog {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/productsView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB,EAAE,wBAAwB;AAChD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,yDAA6C;EAC7C,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAA2C;EAC3C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yDAAgD;EAChD,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,wCAAwC;EACxC,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,yDAAgD;EAChD,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAA+C;EAC/C,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yDAA8C;EAC9C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yDAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yDAAwC;EACxC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0DAA+C;EAC/C,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B,+DAA+D;;AAE/D,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,yDAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yDAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,yDAAwC;EACxC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,0DAA+C;EAC/C,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;AACvB;;;AAGA,kEAAkE;AAClE;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".wrapper {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n}\n\n.header {\n  display: flex;\n  margin-bottom: 20px;\n  justify-content: space-between;\n  position: relative;\n  padding-bottom: 12px; /* отступ перед линией */\n}\n\n.header::before {\n  content: '';\n  z-index: 0;\n  position: absolute;\n  bottom: 11px;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: #e0e0e0;\n}\n\n\n.tabButton {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tabButton:hover {\n  background-color: #e0e0e0;\n}\n\n.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: rgba(29, 135, 82, 1);\n}\n.active {\n  color: rgba(29, 135, 82, 1);\n}\n\n/* Секция кнопок */\n.actions {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.addButton {\n  position: relative;\n  padding: 10.5px 40px 10.5px 18px;\n  background-color: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.addButton::after {\n  content: '';\n  position: absolute;\n  bottom: 14px;\n  right: 15px;\n  height: 8px;\n  width: 16px;\n  background-image: url(/public/add_button.png);\n  background-repeat: no-repeat;\n  background-size: 13.5px 7.5px;\n}\n\n.actionButton {\n  width: 40px;\n  height: 40px;\n  background-image: url(/public/button_2.png);  \n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n/* Секция фильтрации */\n.filters {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 8px;\n}\n\n.filters__select {\n  width: 21%;\n  margin-right: 1%;\n}\n\n.select{\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  min-width: 120px;\n}\n\ntr {\n  border: 1px solid #ccc;\n}\n\n.searchButton {\n  margin-right: 1%;\n  width: 40px;\n  height: 40px;\n  background-image: url(/public/button_search.png);  \n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.searchInput {\n  opacity: 0;\n  width: 0;\n  margin-right: 1%;\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 6px;\n  transition: width 0.3s ease, opacity 0.3s ease, margin-right 0.3s ease;\n  overflow: hidden;\n}\n\n.searchInputVisible {\n  opacity: 1;\n  width: 160px;\n  height: 39px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  margin-right: 8px;\n}\n\n\n.filterButton {\n  width: 45px;\n  height: 40px;\n  background-image: url(/public/button_filter.png);  \n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.clearButton {\n  width: 40px;\n  height: 45px;\n  background-image: url(/public/clear_button.png);  \n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n\n.content {\n  margin-top: 24px;\n  border-radius: 8px;\n}\n\n\n.dropdownWrapper {\n  position: relative;\n}\n\n.dropdown {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n}\n\n.dropdown button {\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 10px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.dropdown button:hover {\n  background-color: #f0f0f0;\n}\n\n.tableWrapper {\n  max-height: 27vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; /* на всякий случай */\n}\n\n/* убери overflow:hidden у самой таблицы, иначе может клипать */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  /* overflow: hidden;  <-- убираем */\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n/* фиксируем шапку внутри scroll-контейнера */\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.checkboxContainer {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.customCheckbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid #1D8752;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: #1D8752;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 16px;\n  padding-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.pageButton {\n  cursor: pointer;\n  padding: 5.5px 6px;\n}\n\n.pageButtonSymbol {\n  cursor: pointer;\n  padding: 5.5px 6px;\n  border-radius: 3px;\n  border: 1px solid rgba(201, 201, 205, 1);\n}\n\n.pageButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.activePage {\n  border: 1px solid rgba(24, 160, 88, 1);\n  color: rgba(24, 160, 88, 1);\n  border-radius: 3px;\n}\n\n.pageDots {\n  padding: 6px 10px;\n  color: #999;\n}\n\n.table th:last-child,\n.table td:last-child{\n  padding: 0 15px 0 0;\n}\n\n.tDots {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  border: none !important;\n  padding: 0 !important;\n}\n\n.optionsButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dots {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dot {\n  width: 4px;\n  height: 4px;\n  background-color: #666;\n  border-radius: 50%;\n}\n\n.settingIcon {\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-image: url(/public/settingIcon.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.rowDropdown {\n  position: absolute;\n  right: 0;\n  margin-top: 8px;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  min-width: 160px;\n}\n\n.rowDropdown button {\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.rowDropdown button:hover {\n  background-color: #f5f5f5;\n}\n\n.tDots {\n  position: relative;\n}\n\n.dropdownWrapper {\n  position: relative;\n}\n\n.optionsDropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  min-width: 222px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.optionsDropdown button {\n  padding: 10px 32px;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.optionsDropdown button:hover {\n  background-color: #f0f0f0;\n}\n\n.show{\n  background-image: url(/public/show.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n.edit{\n  background-image: url(/public/edit.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n.print{\n  background-image: url(/public/print.png);\n  background-repeat: no-repeat;\n  background-position: 10px 9px;\n  background-size: 16px;\n}\n\n.delete{\n  background-image: url(/public/VectorDelete.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n/* productsView.module.css */\n/* ТВОЙ CSS оставь как есть, ниже добавь/замени только нужное */\n\n/* ✅ портальное меню поверх таблицы (не клипается overflow) */\n.optionsDropdownPortal {\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  min-width: 222px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.optionsDropdownPortal button {\n  padding: 10px 32px;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  background: none;\n}\n\n.optionsDropdownPortal button:hover {\n  background-color: #f0f0f0;\n}\n\n/* ✅ оставь твои иконки как есть (они работают по классам) */\n.show{\n  background-image: url(/public/show.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n.edit{\n  background-image: url(/public/edit.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n.print{\n  background-image: url(/public/print.png);\n  background-repeat: no-repeat;\n  background-position: 10px 9px;\n  background-size: 16px;\n}\n\n.delete{\n  background-image: url(/public/VectorDelete.png);\n  background-repeat: no-repeat;\n  background-position: 10px 7px;\n  background-size: 16px;\n}\n\n\n/* фиксируем ширину колонки с точками (и с шестеренкой в header) */\n.table th:last-child,\n.table td:last-child {\n  width: 56px;\n  min-width: 56px;\n  max-width: 56px;\n  padding: 0 !important;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* ВАЖНО: td не должен быть flex */\n.tDots {\n  cursor: pointer;\n  border: none !important;\n  padding: 0 !important;\n  text-align: center;\n}\n\n/* сама кнопка — фикс размер, центр */\n.optionsButton {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin: 0 auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dots {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `productsView_wrapper__OiKbN`,
	"header": `productsView_header__tz4XV`,
	"tabButton": `productsView_tabButton__1TqQu`,
	"active": `productsView_active__AAjak`,
	"actions": `productsView_actions__bCqoZ`,
	"addButton": `productsView_addButton__gTqBg`,
	"actionButton": `productsView_actionButton__J8-vU`,
	"filters": `productsView_filters__gDyM-`,
	"filters__select": `productsView_filters__select__yqlor`,
	"select": `productsView_select__Y+Ki+`,
	"searchButton": `productsView_searchButton__5dJDy`,
	"searchInput": `productsView_searchInput__95bW8`,
	"searchInputVisible": `productsView_searchInputVisible__P7f6a`,
	"filterButton": `productsView_filterButton__A7Hbu`,
	"clearButton": `productsView_clearButton__VNvYF`,
	"content": `productsView_content__eS0xy`,
	"dropdownWrapper": `productsView_dropdownWrapper__W-fhP`,
	"dropdown": `productsView_dropdown__2Lory`,
	"tableWrapper": `productsView_tableWrapper__YAJGG`,
	"table": `productsView_table__UMPhq`,
	"page": `productsView_page__ZB2py`,
	"checkboxContainer": `productsView_checkboxContainer__c9v1e`,
	"customCheckbox": `productsView_customCheckbox__pC-Wi`,
	"pagination": `productsView_pagination__MpN7T`,
	"pageButton": `productsView_pageButton__05Pzs`,
	"pageButtonSymbol": `productsView_pageButtonSymbol__kvY9f`,
	"activePage": `productsView_activePage__8JR7r`,
	"pageDots": `productsView_pageDots__9TKmn`,
	"tDots": `productsView_tDots__kTqo7`,
	"optionsButton": `productsView_optionsButton__x+p7q`,
	"dots": `productsView_dots__chmog`,
	"dot": `productsView_dot__w-DPw`,
	"settingIcon": `productsView_settingIcon__9aYOA`,
	"rowDropdown": `productsView_rowDropdown__RqFYe`,
	"optionsDropdown": `productsView_optionsDropdown__IzEvk`,
	"show": `productsView_show__jgN9r`,
	"edit": `productsView_edit__HKX7S`,
	"print": `productsView_print__lhN9X`,
	"delete": `productsView_delete__3FqO6`,
	"optionsDropdownPortal": `productsView_optionsDropdownPortal__dBeOQ`
};
export default ___CSS_LOADER_EXPORT___;
